import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

import {
  StyledWrapper,
  StyledButtonsWrapper,
  StyledTimeSpan,
  StyledConfirmButton,
  StyledCancelButton,
} from './styles'

const CountdownTimer = ({ onConfirm, onCancel }) => {
  const [isReached, setIsReached] = useState(false)

  const handleConfirm = () => {
    if (isReached && onConfirm) {
      onConfirm()
    }
  }

  const renderRemainTime = ({ remainingTime }) => {
    if (!remainingTime) setIsReached(true)

    return <StyledTimeSpan>{remainingTime}</StyledTimeSpan>
  }

  return (
    <StyledWrapper>
      <CountdownCircleTimer
        isPlaying
        duration={5}
        size={104}
        strokeWidth={8}
        colors={['#273754']}
      >
        {renderRemainTime}
      </CountdownCircleTimer>

      <StyledButtonsWrapper>
        <StyledCancelButton onClick={onCancel}>Cancel</StyledCancelButton>
        <StyledConfirmButton isReached={isReached} onClick={handleConfirm}>
          Confirm
        </StyledConfirmButton>
      </StyledButtonsWrapper>
    </StyledWrapper>
  )
}

CountdownTimer.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default CountdownTimer
